import { BlockUI, AlertMessage, DialogMessage } from '../../Utility.jsx';
import DialogMappingLayout from './MappingLayout.js';
import React, { useState, useMemo, useEffect } from 'react';
import { LayoutModel } from '../../../models/LayoutModel.tsx';
import { useReadMutation, useCreateMutation, useUpdateMutation, useDeleteMutation  } from '../../../hooks/APIRequestHook.tsx';
import { BaseRequestAPIModel, RequestMstLayoutComponentModel, RequestAPIUrlModel } from '../../../models/BaseRequestModel.tsx';
import { BaseResponseAPIModel } from '../../../models/BaseResponseModel.tsx';
import { MST_LAYOUT_READ_URL, MST_LAYOUT_CREATE_URL, MST_LAYOUT_UPDATE_URL, MST_LAYOUT_DELETE_URL, MST_LAYOUT_GET_MAPPING_LAYOUT_URL } from  '../../../const/APIUrl.js';
import { queryListLayoutCacheKey as cacheKey } from  '../../../const/QueryCacheKey.js';
import { formDataToPayload } from '../../../common/Object.tsx';
import { SUCCESSFULLY_SAVE, SUCCESSFULLY_DELETE } from  '../../../const/Message.js';
import { fetchAPI } from '../../../api/GenericFetch.js';
import { fetchWarehouseList } from '../../../services/GetList.js'
import { Dialog } from '@mui/material';

import {
  MaterialReactTable,
  type MRT_ColumnDef,
  type MRT_Row,
  useMaterialReactTable,
} from 'material-react-table';

import {
  FormControl,  
  InputLabel,
  TextField,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize,
  Box,
  Tooltip,
  IconButton,
  Select,
  MenuItem,
  FormGroup,
} from '@mui/material';

import MarginIcon from '@mui/icons-material/Margin';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { setDelay } from  '../../../helpers/UI.js';

const DataTable = (request) => {
  const { data : dataTable, isFetchReadLoading } = useReadMutation<LayoutModel>({url : MST_LAYOUT_READ_URL, cacheKey, enableRefetch : request.enableRefetch});
  const { mutateAsync: deleteUser, isPending: isDeletingUser } = useDeleteMutation<LayoutModel>({cacheKey});
  const [ showDialog, setShowDialog] = useState(false);
  const [ showMappingLayout, setShowMappingLayout ] = useState(false);
  const [ dialogSetting, setDialogSetting ]  = useState({showCloseButton : false, messages : [SUCCESSFULLY_SAVE]});
  const [ isFetching, setIsFetching ] = useState(false);
  const [ mappingLayoutData, setMappingLayoutData ] = useState({});

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleDeleteUser = async (Id: number) => {      
      const request = new BaseRequestAPIModel<LayoutModel>({ Id } as LayoutModel, {} as any, { url: MST_LAYOUT_DELETE_URL } as RequestAPIUrlModel);
      let apiResponse = await deleteUser(request);      
      if (apiResponse.isSuccess !== undefined)
      {
            setShowDialog(true);
            if (!apiResponse.isSuccess) 
            {
                setDialogSetting({...dialogSetting, showCloseButton : true, messages : apiResponse.errorMessages });
            }
            else  {                                
                setDialogSetting({...dialogSetting, showCloseButton : false, messages : [SUCCESSFULLY_DELETE] });
                setDelay().then(() => {
                    setShowDialog(false);
                });
            }          
      }
  };  

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<LayoutModel>) => {
    if (window.confirm('Are you sure you want to proceed?')) {
      handleDeleteUser(row.original.Id);
    }
  };  

  const columns = useMemo<MRT_ColumnDef<LayoutModel>[]>(
    () => [
        { accessorKey: 'Id', header: 'Id', visibleInShowHideMenu: false },        
        { accessorKey: 'LocationId', header: 'LocationId', visibleInShowHideMenu: false, accessorFn: (row) => row.LocationId ?? '' },        
        { accessorKey: 'WarehouseId', header: 'WarehouseId', visibleInShowHideMenu: false, accessorFn: (row) => row.WarehouseId ?? '' },
        { accessorKey: 'LocationName', header: 'Location', accessorFn: (row) => row.LocationName ?? '' },        
        { accessorKey: 'WarehouseName', header: 'Warehouse', accessorFn: (row) => row.WarehouseName ?? '' },     
        { accessorKey: 'LayoutName', header: 'Layout Name', accessorFn: (row) => row.LayoutName ?? '' },        
        { accessorKey: 'TotalColumn', header: 'Total Column', accessorFn: (row) => row.TotalColumn ?? '' },
        { accessorKey: 'TotalRow', header: 'Total Row', accessorFn: (row) => row.TotalRow ?? '' },
        { accessorKey: 'MarginTop', header: 'Margin Top', visibleInShowHideMenu: false , accessorFn: (row) => row.MarginTop ?? '' },
        { accessorKey: 'MarginRight', header: 'Margin Right', visibleInShowHideMenu: false , accessorFn: (row) => row.MarginRight ?? '' },
        { accessorKey: 'MarginBottom', header: 'Margin Bottom', visibleInShowHideMenu: false , accessorFn: (row) => row.MarginBottom ?? '' },
        { accessorKey: 'MarginLeft', header: 'Margin Left', visibleInShowHideMenu: false , accessorFn: (row) => row.MarginLeft ?? '' },
        { accessorKey: 'Notes', header: 'Notes', accessorFn: (row) => row.Notes?.substring(0, 30) ?? '' },
    ],
    [],
  );
  
  const table = useMaterialReactTable({
    columns,
    data: dataTable,
    enableRowActions: true, 
    createDisplayMode: 'modal',
    editDisplayMode:  'modal',
    enableEditing: true,
    state: {
      isLoading: isFetchReadLoading,
      showProgressBars: isFetchReadLoading,
    },
    initialState: {     
      showGlobalFilter: true,
       columnVisibility: {
          Id: false, 
          LocationId: false,
          WarehouseId: false,
          MarginTop: false,
          MarginRight: false,
          MarginBottom: false,
          MarginLeft: false,
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box>
        {request.pageFunction.create &&
          <Button
            startIcon={<AddCircleIcon />}
            variant="contained"
            onClick={() => {
              table.setCreatingRow(true);
            }}
          >
            Add
          </Button>
        }
      </Box>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        {request.pageFunction.update &&
          <Tooltip title="Edit">
            <IconButton onClick={() => table.setEditingRow(row)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        }
        {request.pageFunction.update &&
          <Tooltip title="Delete">
            <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        }
        {request.pageFunction.mappingLayout &&
          <Tooltip title="Mapping Layout">
            <IconButton onClick={async () => {
                  setIsFetching(true);
                  const response = await fetchAPI({url : MST_LAYOUT_GET_MAPPING_LAYOUT_URL + '?Id=' + row.original.Id, body: null});
                  setMappingLayoutData(response.data);
                  setShowMappingLayout(true);
                  setIsFetching(false);
              }}>
              <MarginIcon />
            </IconButton>
          </Tooltip>
        }
      </Box>
    ),
    renderEditRowDialogContent: ({ row, table }) => (     
        <DialogContentModal row={row} table={table} buList={request.buList} gbpList={request.gbpList} title={"Edit"} />
    ),
    renderCreateRowDialogContent: ({ row, table }) => (
        <DialogContentModal row={row} table={table} buList={request.buList} gbpList={request.gbpList}  title={"New"} /> 
    ),
  });

  return(
    <>
      { isDeletingUser || isFetching && <BlockUI /> }
      { showMappingLayout && <DialogMappingLayout rackCategoryList={request.rackCategoryList} rackTypeList={request.rackTypeList} setShowMappingLayout={setShowMappingLayout} mappingLayoutData={mappingLayoutData}/> }
      { showDialog && <DialogMessage dialogSetting={dialogSetting} onClose={handleCloseDialog} />}     
      <MaterialReactTable table={table} />
    </>
  );
};

const DialogContentModal = ({ title, row, table, buList, gbpList }) => {
  row.original.LocationId = (row.original.LocationId === '' ? buList[0].value : row.original.LocationId);
  const [apiResponse, setApiResponse] = useState({} as BaseResponseAPIModel<LayoutModel>);
  const [showDialog, setShowDialog] = useState(false);
  const [gbpListOption, setGBPListOption] = useState(gbpList);
  const [gbpValue, setGBPValue] = useState('');

  const { mutateAsync: createRole, isPending: isCreating } = useCreateMutation<LayoutModel>({cacheKey});
  const { mutateAsync: updateRole, isPending: isUpdating } = useUpdateMutation<LayoutModel>({cacheKey});

  //Create action
  const handleCreateUser = async (data: LayoutModel) => { 
      const request = new BaseRequestAPIModel<LayoutModel>(data, {} as any, { url: MST_LAYOUT_CREATE_URL, additionalUrl : MST_LAYOUT_READ_URL } as RequestAPIUrlModel);
      let response = await createRole(request);  
      setApiResponse(response);
      if (response.isSuccess) {        
        setShowDialog(!showDialog);
        setDelay().then(() => {            
            table.setCreatingRow(null);
        });
      }
  };

  //Update action
  const handleUpdateUser = async (data: LayoutModel, updatedRow : LayoutModel) => {
    const request = new BaseRequestAPIModel<LayoutModel>(data, updatedRow, { url: MST_LAYOUT_UPDATE_URL } as RequestAPIUrlModel);
    console.log(request);
    let response = await updateRole(request);
    setApiResponse(response);    
    if (response.isSuccess) {
        setShowDialog(!showDialog);
        setDelay().then(() => {    
            table.setEditingRow(null);
        });
    }
  };  

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputData = Object.fromEntries(formData.entries());

    let requestData = (formDataToPayload(inputData, row, table) as unknown) as any;

    //custom update for BUName and GBPName
    requestData.LocationName = buList.find(d => d.value === requestData.LocationId)?.text;
    requestData.WarehouseName = gbpListOption.find(d => d.value === requestData.WarehouseId)?.text;

    if (requestData.payload.Id !== undefined && requestData.payload.Id > 0)
    {
      handleUpdateUser(requestData.payload, requestData.updatedRow);
    }
    else
    {
      handleCreateUser(requestData.payload);
    }     
  };

  const getGBPList = async(id) => {
    const response = await fetchWarehouseList(id);
    setGBPListOption(response);
    setGBPValue(row.original.WarehouseId);
  };

  useEffect(() => {        
    getGBPList(row.original.LocationId);
  }, []);

  const handleBUChange = async (e) => {    
    let id = e.target.value;
    const response = await fetchWarehouseList(id);
    setGBPListOption(response);
    setGBPValue('');
  };

  return(
    <>      
      {(isCreating || isUpdating) && <BlockUI />}
      {showDialog && <DialogMessage />}
      <Dialog open={true} className="dialog-overflow-hidden p-1 mui-dialog-custom">
        <form onSubmit={handleFormSubmit} className="row p-3">
              <h1 className="h1">{title}</h1>
              <div className="form-group mb-3">
                {<AlertMessage type={"error"} messages={apiResponse.errorMessages} />}
              </div>
              <TextField name="Id" label="Id" variant="standard" defaultValue={row.original.Id} sx={{ display: { xs: 'none', md: 'none' }}}/>                      
              <TextField name="LocationName" label="Id" variant="standard" defaultValue={row.original.LocationName} sx={{ display: { xs: 'none', md: 'none' }}}/>                             
              <TextField name="WarehouseName" label="Id" variant="standard" defaultValue={row.original.WarehouseName} sx={{ display: { xs: 'none', md: 'none' }}}/>               
              <div className="form-group mb-3">
                <TextField name="LayoutName" className="col-md-12 col-12" label="Layout Name" variant="standard" defaultValue={row.original.LayoutName} />
              </div>
              <FormGroup row>              
                  <FormControl className="w-50 pe-3">
                    <InputLabel id="my-select-label">Location</InputLabel>
                    {buList &&                               
                    <Select name="LocationId" defaultValue={row.original.LocationId} autoWidth={true} onChange={handleBUChange}>
                      {
                        buList.map((d) => (
                        <MenuItem key={d.Id} value={d.value}>{d.text}</MenuItem>
                        ))
                      }
                    </Select>
                  }
                  </FormControl>
                  <FormControl className="w-50">
                    <InputLabel id="my-select-label">Warehouse</InputLabel>
                    {gbpListOption && 
                      <Select name="WarehouseId" value={gbpValue} defaultValue={row.original.WarehouseId} autoWidth={true} onChange={(e) => setGBPValue(e.target.value)}>
                        {
                          gbpListOption.map((d) => (
                          <MenuItem key={d.Id} value={d.value}>{d.text}</MenuItem>
                          ))
                        }
                      </Select>                
                    }                
                  </FormControl>
              </FormGroup>
              <FormGroup row className="mb-3">
                  <TextField name="TotalColumn" className="w-50 pe-2"  label="Total Column" variant="standard" defaultValue={row.original.TotalColumn} />
                  <TextField name="TotalRow" className="w-50 pe-2" label="Total Row" variant="standard" defaultValue={row.original.TotalRow} />              
              </FormGroup>
              <FormGroup row className="mb-3">
                  <TextField name="MarginTop" className="w-25 pe-2"  label="Margin Top" variant="standard" defaultValue={row.original.MarginTop} />
                  <TextField name="MarginRight" className="w-25 pe-2" label="Margin Right" variant="standard" defaultValue={row.original.MarginRight} />
                  <TextField name="MarginBottom"  className="w-25 pe-2"label="Margin Bottom" variant="standard" defaultValue={row.original.MarginBottom} />
                  <TextField name="MarginLeft" className="w-25 pe-2" label="Margin Left" variant="standard" defaultValue={row.original.MarginLeft} />
              </FormGroup>
              <div className="form-group mb-3">
                <TextareaAutosize
                  className="col-md-12 col-12"
                  name="Notes"
                  aria-label=""
                  minRows={4}
                  placeholder="Notes"
                  defaultValue={row.original.Notes}
                />
              </div>
             <div className="form-group text-end">
              <Button className="col-lg-2 col-md-12 col-12"
                onClick={() => {
                  table.setCreatingRow(null);                
                  if (row.original.Id > 0){
                    table.setEditingRow(null);
                  } 
                }}
              >
                Cancel
              </Button>
              <Button className="col-lg-2 col-md-12 col-12" type="submit" variant="contained" disabled={isCreating || isUpdating}>Save</Button>
            </div>
          </form>
      </Dialog>
    </>
  );
};

const MstLayoutComponent: React.FC<RequestMstLayoutComponentModel> = ({buList, gbpList, rackTypeList, rackCategoryList, pageFunction}) => {
  const [enableRefetch , setEnableRefetch] = useState(true);

  useEffect(() => {
    setEnableRefetch(false);
  },[enableRefetch]);

  return (
    <>        
      <DataTable enableRefetch={enableRefetch} buList={buList} gbpList={gbpList} rackTypeList={rackTypeList} rackCategoryList={rackCategoryList} pageFunction={pageFunction}/>
    </>
  );
};

export default MstLayoutComponent;